<template>
  <div>
    <b-modal cancel-title="Annulla" v-model="confirmDeleteModal" size="md" scrollable  @ok="handleDeleteConfirm()" @cancel="confirmDeleteModal = false">
      <div class="p-5">
        <h5 v-if="!type">
          Sei sicuro di eliminarlo?
        </h5>
        <h5 v-if="type == 'report'">
          Eliminare il report ?
        </h5>
      </div>
    </b-modal>

    <b-button title="Delete" class="p-0 mr-2 color_black" style="margin-bottom: 2px;!important"  @click="confirmDeleteModal = true"  variant="default" >
      <font-awesome-icon icon="trash-alt" class="icon" />
      <!-- <img  title="Delete" src="/static/icons/deleteicon.png" width="16"> -->
      <slot></slot>
    </b-button>

  </div>
</template>

<script>

export default {
  name: "deletePage",
  components: {
  },
  props:{
    loc:{
      required:true
    },
    type:{
      required:false
    }
  },
  data() {
    return {
      confirmDeleteModal:false,
    };
  },

  mounted() {

  },

  watch: {},

  methods: {
    handleDeleteConfirm(){
      this.$emit('handleDeletePage', this.loc);
    }

  },

  computed: {

  },

};
</script>

<style scoped>
  .icon {
    color: red;
  }
</style>



// WEBPACK FOOTER //
// src/components/Reports/deleteConfirm.vue